import { useGetSavingsProductsQuery } from "@/services/savingsAPI";
import {
  Box,
  Button,
  Flex,
  Image,
  Space,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import SavingDetailDrawer from "./components/SavingDetailDrawer";
import { useDisclosure } from "@mantine/hooks";
import { useState } from "react";
import { SavingsProduct } from "@/dto/savings/Savings";
import { useNavigate } from "react-router-dom";
import RoutesString from "@/pages/routesString";
import savingCardBg from "./assets/saving-card-bg.jpg";
import { useTranslation } from "react-i18next";
import { beText } from "@/utils/beText";

const SavingListWrapper = () => {
  const { t } = useTranslation();

  const { data: dataSavings } = useGetSavingsProductsQuery();
  const [saving, setSaving] = useState<SavingsProduct | null>(null);
  const [opened, { open, close }] = useDisclosure(false);
  const navigate = useNavigate();
  return (
    <>
      <Box
        sx={{
          position: "relative",
          paddingLeft: 14,
          marginBottom: 10,
          "&::before": {
            content: '""',
            position: "absolute",
            left: 0,
            top: 8,
            bottom: 8,
            width: 6,
            borderRadius: 6,
            background:
              "linear-gradient(265.56deg, #246CF9 -0.27%, #1E68F6 -0.26%, #0047D0 98.59%)",
          },
        }}
      >
        <Title fw={800} fz={24} py={10}>
          {t("TERM_DEPOSIT_PRODUCT_LIST")}
        </Title>
      </Box>
      <Space h={24} />
      <Flex wrap="wrap" gap={24}>
        {dataSavings?.body.products.map((item) => (
          <Stack
            style={{
              borderRadius: "16px",
              background: "#fff",
              width: "30%",
            }}
            spacing={0}
            key={item.type}
          >
            <Image
              src={item.image}
              height={200}
              fit="contain"
              radius="md"
              sx={{
                overflow: "hidden",
                borderRadius: "16px 16px 0 0",
                background: `linear-gradient(86.29deg, rgba(26, 149, 232, 0.75) -5.13%, rgba(118, 205, 232, 0.75) 84.17%), url(${savingCardBg})`,
                backgroundSize: "cover",
              }}
            />
            <Stack p={12} spacing={12} style={{ flex: 1 }}>
              <Text fw={600} fz={16} pt={10}>
                {beText(item.title)}
              </Text>
              <Text fz={14} c="#64758F">
                {beText(item.desc)}
              </Text>

              <Flex gap={12} mt="auto">
                <Button
                  style={{ borderRadius: "12px" }}
                  w="50%"
                  onClick={() => {
                    navigate(RoutesString.TermDepositForm, {
                      state: { type: item.type },
                    });
                  }}
                >
                  {t("REGISTER")}
                </Button>
                <Button
                  style={{ borderRadius: "12px" }}
                  w="50%"
                  variant="outline"
                  onClick={() => {
                    setSaving(item);
                    open();
                  }}
                >
                  {t("DETAIL")}
                </Button>
              </Flex>
            </Stack>
          </Stack>
        ))}
      </Flex>
      <SavingDetailDrawer
        opened={opened}
        close={close}
        data={saving ?? undefined}
        onSubmit={() => {
          navigate(RoutesString.TermDepositForm, {
            state: { type: saving?.type },
          });
        }}
      />
    </>
  );
};
export default SavingListWrapper;
